import React from 'react';
import Header from '../Header/Header';
import Category from '../Category/Category';
import Footer from '../../../common/Footer/Footer';

import * as classes from './homePageLayout.module.css';

export default function HomePageLayout({ children, categories }) {
  return (
    <div className={classes.site}>
      <div className={classes.site_Content}>
        <Header />
        <Category categories={categories} />
        {children}
        <Footer />
      </div>
    </div>
  );
}
